<template>
  <el-dialog title="更多筛选条件" :visible.sync="showDialog" :center="true" class="condition-dialog" :width="!params.investigatorFilter? '700px':'900px'" top="0" 
    :destroy-on-close="true"
    :append-to-body="params.investigatorFilter"
    :modal="params.investigatorFilter"
    >
    <div class="body_container">
      <tree-condition ref="treeCondition" />
    </div>
    <template class="dialog-footer" #footer>
      <footer class="d_footer">
        <el-button type="text" size="small" @click="clearAll">清空全部条件</el-button>
        <div>
          <el-button type="primary" size="small" @click="cancelFilter">取消</el-button>
          <el-button type="primary" size="small" @click="saveFilter">确定</el-button>
        </div>
      </footer>
    </template>
  </el-dialog>
</template>

<script>
import TreeCondition from './tree-condition/index'
import { COMMON } from './tree-condition/constants'

export default {
  name: 'DialogCondition',
  components: {
    TreeCondition
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filter: {
      type: [Object, null],
      default: null
    }
  },
  inject: {
    params:{
      default: () => ({
        data: '',
        investigatorFilter:true
      })
    }
  },
  model: {
    event: 'visibility',
    prop: 'visible'
  },
  data() {
    return {
      isClick: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.visible
      },
      set(bool) {
        this.$emit('visibility', bool)
      }
    }
  },
  watch: {
    visible(bool) {
      if (bool) {
        this.$nextTick(() => {
          if (this.$refs.treeCondition && this.filter !== null) {
            if (
              Object.entries(this.filter).length > 0 &&
              ((Array.isArray(this.filter.rules) && this.filter.rules.length > 0) ||
                (Array.isArray(this.filter.ruleGroups) && this.filter.ruleGroups.length > 0))
            ) {
              this.$refs.treeCondition.setFilterValue(this.filter)
              this.$refs.treeCondition.flushLabelOption()
            }
          }
        })
      } else {
        this.$refs.treeCondition.clearFilterValue()
      }
    }
  },
  methods: {

    deepHandleData(rules){
      if( rules instanceof Array && rules.length > 0) {
        rules.forEach(it=> {
          it.rules.forEach(itChild=> {
            if(itChild.classify === 3){
              itChild.type = 'nop'
            }
          })
          if( Array.isArray(it.ruleGroups) && it.ruleGroups.length >0 ){
            this.deepHandleData(it.ruleGroups);
          }
        })
      }

    },
    saveFilter() {
      if (this.isClick) return
      const filter = JSON.parse(JSON.stringify(this.$refs.treeCondition.getFilterValue())); 
      console.log('filter',filter)
      this.deepHandleData(filter.ruleGroups);
      if(Array.isArray(filter.rules)){
        filter.rules.forEach(it=> {
          if(it.classify === 3){
            it.type = 'nop'
          }
        })
      }
      if (filter === null || this.checkFilterNull(filter)) {
        this.isClick = true
        this.$emit('update:filter', this.$refs.treeCondition.getFilterValue())
        this.$emit('save', filter)
        this.$nextTick(() => {
          this.cancelFilter()
        })
      } else {
        this.$message.warning('请完善筛选条件')
      }
    },
    cancelFilter() {
      this.$emit('visibility', false)
      setTimeout(() => {
        this.isClick = false
      }, 300)
    },
    clearAll() {
      this.$refs.treeCondition.clearFilterValue();
      this.$emit('update:filter', {
        conditionRule: 2,
        ruleGroups: [],
        rules: []
      });
      this.$emit('save');
      this.$nextTick(() => {
        this.cancelFilter();
      });
    },
    checkFilterNull(filter) {
      if (filter.rules.length > 0) {
        for (const rule of filter.rules) {
          if(rule.classify === 3){

          }else{
            if (rule.fieldName === '' || rule.type === '') {
              return false
            } else if (!Object.values(COMMON).includes(rule.type)) {
              const paramsArr = Array.isArray(rule.params) ? rule.params : [rule.params]
              if (paramsArr.length === 0) return false
              const isNil = paramsArr.some(s => [undefined, null, ''].includes(s))
              if (isNil) return false
            }
          }
        }
      } else {
        return false
      }
      if (filter.ruleGroups.length > 0) {
        for (const rg of filter.ruleGroups) {
          const check = this.checkFilterNull(rg)
          if (!check) return check
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.condition-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-dialog {
    border-radius: 8px;
    margin-bottom: 0;
    &__header {
      padding: 12px 24px;
      border-radius: 8px;
      background-color: #f5f7fa;
      text-align: left;
    }
    &__body {
      padding: 0;
      height: 400px !important;
    }
    &__footer {
      padding: 16px 20px;
      border-top: 1px solid rgba($color: #ccc, $alpha: 0.5);
    }
    .body_container {
      width: 100%;
      height: 100%;
      padding: 16px;
      box-sizing: border-box;
      overflow: auto;
    }
  }
  .d_footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
